import { render, staticRenderFns } from "./ruleDom.vue?vue&type=template&id=78189e03&scoped=true&"
import script from "./ruleDom.vue?vue&type=script&lang=js&"
export * from "./ruleDom.vue?vue&type=script&lang=js&"
import style0 from "./ruleDom.vue?vue&type=style&index=0&id=78189e03&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78189e03",
  null
  
)

export default component.exports